module.exports = __webpack_public_path__ + "static/media/left2.38181b45.svg";